var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 7.3125H5.625V14.625H2.25C2.10082 14.625 1.95774 14.5657 1.85225 14.4602C1.74676 14.3548 1.6875 14.2117 1.6875 14.0625V7.875C1.6875 7.72582 1.74676 7.58274 1.85225 7.47725C1.95774 7.37176 2.10082 7.3125 2.25 7.3125V7.3125Z",
    stroke: "#525252",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 7.3125L8.4375 1.6875C9.03424 1.6875 9.60653 1.92455 10.0285 2.34651C10.4504 2.76847 10.6875 3.34076 10.6875 3.9375V5.625H15.0398C15.1994 5.62461 15.3571 5.65835 15.5025 5.72397C15.6479 5.7896 15.7776 5.88557 15.8828 6.00546C15.988 6.12534 16.0664 6.26636 16.1126 6.41903C16.1588 6.57171 16.1718 6.7325 16.1508 6.89062L15.307 13.6406C15.2729 13.9116 15.1414 14.1609 14.9369 14.342C14.7325 14.5231 14.4692 14.6237 14.1961 14.625H5.625",
    stroke: "#525252",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThumbsUp);
export default __webpack_public_path__ + "static/media/icon_ThumbsUp.9b1f52e4442a8b9efc22ff0c49c42a7f.svg";
export { ForwardRef as ReactComponent };